import { useEffect, useState } from "react";

const MINUTE_MS = 60_000;

/**
 * Đếm ngược tới `endsAt`. Label dạng "2d 14h 23m", nhưng khi còn dưới 1 phút thì
 * chuyển sang đếm từng giây ("45s").
 *
 * `intervalMs` (mặc định 1 phút) chỉ là nhịp tick lúc còn nhiều thời gian; phút
 * cuối luôn tự tick mỗi giây bất kể tham số này.
 */
const useCountdown = (endsAt, intervalMs = MINUTE_MS) => {
  const [now, setNow] = useState(() => Date.now());

  // endsAt có thể là undefined/chuỗi rác lúc chưa có data từ API -> coi như hết
  // giờ thay vì để NaN lan xuống nhịp tick bên dưới.
  const endTime = new Date(endsAt).getTime();
  const remainingMs = Number.isFinite(endTime) ? Math.max(0, endTime - now) : 0;
  const isOver = remainingMs === 0;

  /* Phút cuối: tick mỗi giây. Trước đó: tick mỗi intervalMs, nhưng không bao giờ
     muộn hơn thời điểm chạm mốc 60s — nếu cứ tick 60s một lần thì có thể nhảy
     thẳng từ "2m" xuống "1s" và mất gần hết phần đếm giây. */
  const tickMs =
    remainingMs <= MINUTE_MS
      ? 1000
      : Math.min(intervalMs, remainingMs - MINUTE_MS);

  useEffect(() => {
    if (isOver) return undefined;
    const id = setInterval(() => setNow(Date.now()), tickMs);
    return () => clearInterval(id);
  }, [tickMs, isOver]);

  const totalMinutes = Math.floor(remainingMs / MINUTE_MS);
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes / 60) % 24);
  const minutes = totalMinutes % 60;
  const seconds = Math.floor((remainingMs / 1000) % 60);

  const label =
    remainingMs < MINUTE_MS
      ? `${seconds}s`
      : [
          days > 0 && `${days}d`,
          (days > 0 || hours > 0) && `${hours}h`,
          `${minutes}m`,
        ]
          .filter(Boolean)
          .join(" ");

  return { days, hours, minutes, seconds, label, isOver };
};

export default useCountdown;
